<template>
  <div class="w-full h-3 flex rounded-full" style="background-color: #F7F7FF;">
    <div :class="`h-3 rounded-full ${color}`" :style="`width: ${value}%`" />
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    value: {
      type: String,
      default: "0"
    }
  },
  computed: {
    color() {
      const percent = Number(this.value);
      if (!Number.isFinite(percent) || percent <= 0) {
        return "";
      }
      if (percent < 30) {
        return "bg-desire";
      }
      if (percent < 100) {
        return "bg-carrotOrange";
      }
      return "bg-mediumSeaGreen";
    }
  }
};
</script>
